// DS: DEV10
import React from 'react';
import StatisticsBarItem from './StatisticsBarItem';
import s from './StatisticsBar.scss';
var StatisticsBar = function (_a) {
    var stats = _a.stats, className = _a.className;
    return (React.createElement("div", { className: className }, stats.map(function (stat) {
        return stat && (React.createElement(StatisticsBarItem, { key: stat.label, icon: stat.icon, label: stat.label, className: s['stat-item'] }));
    })));
};
StatisticsBar.displayName = 'StatisticsBar';
export default StatisticsBar;
//# sourceMappingURL=StatisticsBar.js.map